import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuthStore } from '../store/authStore';

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { token, user } = useAuthStore();
  const location        = useLocation();

  // Not authenticated → redirect to login, preserve intended destination
  if (!token || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Token expiry check (JWT exp claim)
  try {
    const payload    = JSON.parse(atob(token.split('.')[1]!));
    const expiredAt  = payload.exp * 1000;
    if (Date.now() > expiredAt) {
      useAuthStore.getState().logout();
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
  } catch {
    // Malformed token — clear and redirect
    useAuthStore.getState().logout();
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}